import IMAGE from "../../../constants/images";

export const DOCUMENT_EXAMPLES = [
    {
        title: 'Documents you may have received during care—',
        image: IMAGE.STETHOSCOPE_CLIPBOARD,
        listItems: [
            'Imaging results (X-ray, MRI, etc)',
            'Test results',
        ]
    },
    {
        title: 'Documents or results you may have received after treatment—',
        image: IMAGE.HOSPITAL_EXIT,
        listItems: [
            'Hospital discharge paperwork',
            'Physician notes',
        ]
    },
    {
        title: 'Documents you may have received later—',
        image: IMAGE.ENVELOPE_EOB,
        listItems: [
            'Completed provider claim form',
            'Provider bill with diagnosis',
        ]
    },
];


export default DOCUMENT_EXAMPLES;